<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th colspan="18" class="no-border">
            <div class="d-flex justify-content-end">
              <h3 class="pl-3">Activiteiten</h3>
            </div>
          </th>
        </tr>
        <tr>
          <th colspan="18" class="no-border">
            <div class="d-flex justify-content-end">
              <a
                v-if="userHasPermissions(['Absentie verantwoordelijke(n)'])"
                class="btn btn-md btn-outline-dark mr-5"
                :class="['btn-dark text-white']"
                href="#createEventModal"
                data-toggle="modal"
                @click="initialiseModal"
                ><i class="fas fa-plus"></i
              ></a>

              <a
                @click="filterEvent('past')"
                class="btn btn-md btn-outline-dark dark-text mr-5"
                :class="[
                  active
                    ? 'btn-dark text-white'
                    : 'btn-outline-dark text-black',
                ]"
              >
                Historie
              </a>
              <a
                @click="filterEvent('upcoming')"
                class="btn btn-md rounded dark-text"
                :class="[!active ? 'btn-dark text-white' : 'btn-outline-dark ']"
              >
                Aankomend
              </a>
            </div>
          </th>
        </tr>
        <tr>
          <th>Begindatum</th>
          <th>Einddatum</th>
          <th>Activiteittype</th>
          <th>Titel</th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <th>
            <input
              v-model="filter_start_date"
              type="date"
              class="form-control"
            />
          </th>
          <th>
            <input v-model="filter_end_date" type="date" class="form-control" />
          </th>
          <th>
            <select2
              :options="
                eventtypes.map((d) => {
                  return { id: d.id, text: d.title };
                })
              "
              :settings="{}"
              v-model="filter_eventtype_title"
            ></select2>
          </th>
          <th>
            <input
              v-model="filter_event_title"
              type="text"
              class="form-control"
            />
          </th>
          <th>
            <button
              @click="filterEvent()"
              class="rounded btn btn-md btn-dark text-white"
            >
              Zoeken
            </button>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <thead></thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="5" class="text-center">Aan het laden...</td>
        </tr>
        <tr v-for="(event, index) in events" :key="index">
          <td>{{ event.date_start }}</td>
          <td>{{ event.date_end }}</td>
          <td>
            <span v-if="event.eventtype">
              {{ event.eventtype.title }}
            </span>
          </td>
          <td>{{ event.title }}</td>
          <td>
            <a
              @click="toggle(event.id, 1)"
              v-if="event.canceled == 0"
              class="btn btn-sm btn-success text-white"
              >Ingepland</a
            >
            <a
              @click="toggle(event.id, 0)"
              v-else
              class="btn btn-sm btn-danger text-white"
              >Geannuleerd</a
            >
          </td>
          <th>
            <a
              :href="'/community/events/' + event.id + '/absentie'"
              class="btn btn-dark text-white btn-sm small-size"
              >Absentie</a
            >
          </th>

          <th>
            <a
              data-toggle="modal"
              data-target="#eventModal"
              class="btn btn-dark text-white btn-sm small-size"
              @click="showEventDetail(event)"
            >
              Open
            </a>
          </th>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="18">
            <div class="d-flex justify-content-end" v-if="events.length > 0">
              <a
                v-if="current_page != prev_page"
                @click="filterEvent('upcoming', prev_page)"
                class="mr-3"
                style="cursor: pointer"
              >
                <i class="fa fa-chevron-left"></i>
              </a>
              <a
                v-if="current_page != next_page"
                @click="filterEvent('upcoming', next_page)"
                style="cursor: pointer"
              >
                <i class="fa fa-chevron-right"></i>
              </a>
            </div>
          </th>
        </tr>
      </tfoot>
    </table>

    <div
      class="modal fade"
      id="createEventModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="min-width: 999px">
        <event-form
          :committee="null"
          :event="{}"
          :eventtypes="eventtypes"
          :force-update="0"
          :start_date="start_date"
          :absentie="true"
        ></event-form>
      </div>
    </div>

    <div
      class="modal fade"
      id="eventModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 1000px">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <div class="modal-title w-100 d-flex justify-content-between h5">
              <div>{{ openedEvent.title }}</div>
              <div>
                {{ openedEvent.date_start | formatDate }} -
                {{ openedEvent.date_end | formatDate }}
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-12"
                v-if="openedEvent.description && openedEvent.description.length"
              >
                <h6>Omschrijving</h6>
                <p v-html="openedEvent.description"></p>
              </div>

              <div
                class="col-12 mt-4"
                v-if="openedEvent.remarks && openedEvent.remarks.length"
              >
                <h6>Remark</h6>
                <p v-html="openedEvent.remarks"></p>
              </div>
              <div class="col-lg-12">
                <button data-dismiss="modal" class="btn-dark float-right mt-3">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import EventForm from "../../events/event_form.vue";
import { mapState } from "vuex";

export default {
  name: "index",
  components: { EventForm },
  data() {
    return {
      showFilterInputs: false,
      events: [],
      eventtypes: [],
      search: {},
      active: 0,
      next_page: 1,
      prev_page: 1,
      loading: false,
      current_page: 1,
      isUpcoming: true,
      filter_start_date: null,
      filter_end_date: null,
      filter_eventtype_title: null,
      filter_event_title: null,
      openedEvent: {},
      start_date: new Date().toDateString,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  created() {
    // console.log(this.user)
    this.$store
      .dispatch("get", "api/v1/get-eventtypes")
      .then((data) => {
        this.eventtypes = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.filterEvent('upcoming');
  },
  methods: {
    initialiseModal() {
      var date = new Date();
      this.start_date =
        date.getFullYear() +
        "-" +
        date.getMonth() +
        "-" +
        date.getDate() +
        "T" +
        date.getHours() +
        ":" +
        date.getMinutes();
    },

    showEventDetail(event) {
      this.openedEvent = event;
    },

    filterEvent(period) {
      if (this.loading) return false;
      this.isUpcoming = period === "upcoming";
      let filter = this.isUpcoming ? "upcoming" : "past";
      this.loading = true;
      this.active = this.isUpcoming ? 0 : 1;
      this.events = [];

      this.$store
        .dispatch(
          "get",
          `/api/v1/events?filter=${filter}&start=${this.filter_start_date}&end=${this.filter_end_date}&page=${this.current_page}&eventtype_title=${this.filter_eventtype_title}&event_title=${this.filter_event_title}`
        )
        .then((data) => {
          // console.log(data)
          let events;

          if (this.userHasPermissions(["Beheer Activiteiten"])) {
            events = data.data.data;
          } else {
            events = data.data.data.filter((item) => {
              return item.attendees.includes(this.$store.state.auth.user.id);
            });
          }

          this.events = [...events];
          //this.events=[...data.data.data];
          if (data.data.next_page_url != null) {
            this.next_page = data.data.current_page + 1;
          }
          if (data.data.prev_page_url != null) {
            this.prev_page = data.data.current_page + -1;
          }
          this.current_page = data.data.current_page;
          this.loading = false;

          window.$(document).ready(function() {
            window
              .$(".table-responsive")
              .doubleScroll({ resetOnWindowResize: true });
          });
        })
        .catch((error) => {
          console.log(error.request);
          this.loading = false;
        });
    },
    toggle(id, val) {
      this.$store
        .dispatch("post", {
          endpoint: `/api/v1/events/cancel/${id}`,
          details: {
            canceled: val,
          },
        })
        .then(() => {
          const index = this.events.findIndex((item) => item.id === id);
          this.$set(this.events[index], "canceled", val);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
  },
  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
    },
  },
  watch: {
    // eslint-disable-next-line
    /* filter_start_date(value) {
      this.filterEvent();
    }, */
    // eslint-disable-next-line
    /*  filter_end_date(value) {
      this.filterEvent();
    }, */
    // eslint-disable-next-line
    /* filter_eventtype_title(value) {
      this.filterEvent();
    }, */
    // eslint-disable-next-line
    /* filter_event_title(value) {
      this.filterEvent();
    }, */
  },
};
</script>

<style scoped>
.small-size {
  font-size: 0.875rem !important;
}
.no-border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
}
</style>
